export enum DermloopUserMustResetPasswordEnum {
  UserMustReset = 'UserMustReset',
  AdminMustReset = 'AdminMustReset',
}
